// extracted by mini-css-extract-plugin
export default {"header":"jQ-z"};